const userRoles = {
    agentsOnly : ['corporate_agent', 'sailor', 'intermediary_agent', 'sales_admin', 'intermediary_admin'],
    simpleAdmins : ['corporate_agent', 'sailor', 'intermediary_agent', 'sales_admin', 'insurer_admin', 'insurer_regulator', 'insurer_association_admin', 'sinbad_admin'],
    superAdmins : ['insurer_admin', 'insurer_regulator', 'insurer_association_admin', 'sinbad_admin'],
    all : ['corporate_agent', 'sailor', 'intermediary_agent', 'sales_admin', 'insurer_admin', 'intermediary_admin', 'insurer_regulator', 'insurer_association_admin', 'sinbad_admin'],
    taxAgent : ['tax_agency_admin'],
    insurerOnly : ['insurer_admin'],
    sinbadAdmins : ['insurer_regulator', 'insurer_association_admin', 'sinbad_admin'],
}

export default  userRoles;


// WEBPACK FOOTER //
// ./src/utils/user-roles.js